<template>
	<div>
		<el-card class="guest-container">
			<template #header>
			  <div class="header">
			    <el-button type="primary" size="small" icon="el-icon-plus" @click="addMenu('')">新增</el-button>
			  </div>
			</template>
			<el-table
			    :data="tableData"
			    style="width: 100%"
			    row-key="id"
			    border
			    :tree-props="{children: 'all_children'}">
			    <el-table-column
			      prop="title"
			      label="菜单标题"
			      width="180">
			    </el-table-column>
			    <el-table-column
			      prop="sort"
			      label="排序"
			      width="180">
			    </el-table-column>
			    <el-table-column
			      prop="created_at"
			      label="创建日期">
			    </el-table-column>
				<el-table-column
				  label="操作"
				  width="auto"
				>
				  <template #default="scope">
				    <!-- <a style="cursor: pointer; margin-right: 10px" @confirm="handleSolve(scope.row)">解除禁用</a> -->
					<el-button type="primary" size="mini" @click="edit(scope.row)">编辑</el-button>
					<el-button type="warning" size="mini" @click="del(scope.row)">删除</el-button>
				  </template>
				</el-table-column>
			  </el-table>
		</el-card>	
	</div>
</template>

<script>
	export default{
		data(){
			return{
				tableData:[],
			}
		},
		methods:{
			getAllMenu(){
				this.httpPost({
					url:'/admin/menu/menu_list',
					data:{
						routePath: this.$route.path
					}
				}).then((res)=>{
					this.tableData=res.data;
				})
			},
			del(val){
				if(val.all_children !==undefined && val.all_children.length > 0 ){
					this.$message.error('该分类下还有子分类，不能删除！');
					return false;
				}else{
					let id = val.id;
					this.msgBoxAjax(
					  '提示',
					  '确定删除吗？',
					  "/admin/menu/del",
					  {id:id}).then((data) => {
					  // console.log(data);
								
					  if (data.code == 1) {
					    this.messageSuccess('提示', '删除成功！').then(() => {
							
				      this.$router.go(0);
				    });
					  }else{
								
					    this.messageCommon('错误',data.msg,'error');
					  }
								
								
					});
				}
			},
			edit(val){
				this.$router.push({
				          path: '/main/menu_edit',
				          query: {
				            id: val.id,
				          },
						  params:{
							  
						  }
				        });
			},
			addMenu(obj){
				this.$router.push({
				          path: '/main/menu_edit',
				          query: {
				            id: obj.id,
							
				          }
				        });
			},
			// load(tree, treeNode, resolve) {
			// 		setTimeout(() => {
			// 		  resolve(tree.all_children)
			// 		}, 1000)
			// }
		},
		created() {
			this.getAllMenu();
		}
	}
</script>

<style>
</style>
